/* tslint:disable */

declare var Object: any;
export interface TitleInterface {
  "page"?: string;
  "title"?: any;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class Title implements TitleInterface {
  "page": string;
  "title": any;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: TitleInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Title`.
   */
  public static getModelName() {
    return "Title";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Title for dynamic purposes.
  **/
  public static factory(data: TitleInterface): Title{
    return new Title(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Title',
      plural: 'Titles',
      path: 'Titles',
      idName: 'id',
      properties: {
        "page": {
          name: 'page',
          type: 'string'
        },
        "title": {
          name: 'title',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
